import { useEffect, useRef } from "react";

/**
 * Binds Ctrl+S / Cmd+S to `saveFn` while the component is mounted.
 * Pass `disabled` to suppress the shortcut (e.g. while a save is in flight
 * or the design is released).
 */
export default function useSaveShortcut(saveFn, { disabled = false } = {}) {
  const saveFnRef = useRef(saveFn);
  useEffect(() => { saveFnRef.current = saveFn; }, [saveFn]);

  useEffect(() => {
    const handler = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
        if (!disabled) saveFnRef.current?.();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [disabled]);
}
